// productSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { productService } from "./productService";
import { getUserProductWishlist } from "../user/userSlice";
import { toast } from "react-hot-toast";

export const getAllProducts = createAsyncThunk(
  'product/get',
  async (searchTerm = '', thunkAPI) => {
    try {
      const response = await productService.getProducts(searchTerm);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || 'Failed to fetch products');
    }
  }
);

export const addTowishlist = createAsyncThunk(
  "user/addwishlist",
  async (prodId, thunkAPI) => {
    try {
      const response = await productService.addTowishlist(prodId);
      // Refresh the wishlist after toggling
      await thunkAPI.dispatch(getUserProductWishlist()).unwrap();
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to update wishlist";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);


export const getAProduct = createAsyncThunk(
  "product/getSingle", // Changed to "product/getSingle"
  async (id, thunkAPI) => {
    try {
      const response = await productService.getSingleProduct(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to fetch product");
    }
  }
);


// Fetch products by category and subcategory
export const getCategoryAndSubcategoryProducts = createAsyncThunk(
  "product/getCategoryAndSubcategory",
  async ({ category, subCategory }, thunkAPI) => {
    try {
      const response = await productService.categoryAndSubcategoryWiseProductList(category, subCategory);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to fetch products by category and subcategory");
    }
  }
);

const initialState = {
  product: [], // Should be an array to use array methods like filter
  singleProduct: {}, // For individual product details
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: ""
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.product = action.payload;
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || action.error.message;
      })
      .addCase(getCategoryAndSubcategoryProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategoryAndSubcategoryProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.product = action.payload;
      })
      .addCase(getCategoryAndSubcategoryProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || action.error.message;
      })
      .addCase(getAProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAProduct.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.singleProduct = action.payload;
      })
      .addCase(getAProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || action.error.message;
      }).addCase(addTowishlist.pending,(state)=>{
        state.isLoading=true;
      }).addCase(addTowishlist.fulfilled,(state,action)=>{
        state.isLoading=false;
        state.isSuccess=true;
        state.isError=false;
        state.addTowishlist=action.payload;
        state.message="product Added To wishlist !"
      }).addCase(addTowishlist.rejected,(state,action)=>{
        state.isLoading=false;
        state.isError=true;
        state.isSuccess=false;
        state.message=action.error
      })
  }
});

export default productSlice.reducer;
